import { render, staticRenderFns } from "./TransactionBadge.vue?vue&type=template&id=4d4d31e5&"
import script from "./TransactionBadge.vue?vue&type=script&lang=ts&"
export * from "./TransactionBadge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports